// extracted by mini-css-extract-plugin
export default {"cardRow":"styles_cardRow__MGJ83","backButtonContainer":"styles_backButtonContainer__TNz9a"};